import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { ApplicationPathConstants } from '@ddt-web/config';
import { AuthenticationManageService } from '@ddt-web/core';
import { ApplicationConstants, ModelRowData } from '@ddt-web/models-browsing';

@Component({
	selector: 'me-mini-compare-bar',
	templateUrl: './mini-compare-bar.component.html',
	styleUrls: ['./mini-compare-bar.component.scss']
})
export class MiniCompareBarComponent {
	@Input() public selectedModelsToCompare: Array<ModelRowData> = [];
	@Output() private openMiniCompareDialog = new EventEmitter<Array<any>>();
	@Output() private removeSelectedModel = new EventEmitter<Array<ModelRowData>>();

	public readonly noOfModels: number = ApplicationConstants.MAX_MODELS_FOR_COMPARISON;
	public isExpanded: boolean = true;

	constructor(private tealiumAnalyticsService: TealiumAnalyticsService, private authManagerService: AuthenticationManageService) { }

	public onCompareModels(): void {
		this.tealiumAnalyticsService.triggerToolCompletion(null, TealiumConstants.TOOL_NAMES.MODELS_EXPERIENCE, TealiumConstants.MODELS_EXPERIENCE_EVENTS.COMPARE);
		this.openMiniCompareDialog.emit();
	}

	public updateSelectedModels(event: Event, selectedCard: ModelRowData): void {
		event.preventDefault();
		this.selectedModelsToCompare = this.selectedModelsToCompare.filter(compareModel => compareModel?.['modelId'] !== selectedCard?.['modelId']);
		const eventName = TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + `:mini compare bar:removed selected model:${selectedCard?.['modelId']}`;
		this.tealiumAnalyticsService.trackEventTealium(new TealiumAnalyticsEvent(eventName, {
			toolName: TealiumConstants.TOOL_NAMES.MODELS_EXPERIENCE
		}));

		this.removeSelectedModel.emit(this.selectedModelsToCompare);
	}

	public signIn(): void {
		this.authManagerService.initializeOktaSignIn({ 'redirectUrlPath': '/' + ApplicationPathConstants.MODELS_EXPERIENCE_PATHS.FIND_AND_COMPARE });
	}

	public clearAllSelections(): void {
		this.selectedModelsToCompare = [];
		this.removeSelectedModel.emit(this.selectedModelsToCompare);
	}
}
